import { MemberEventsService } from '../../../services/member.events.service';
import { Subscription } from 'rxjs';
import { EntityChangedArgs } from '../../../managers/manager.base';
import { NoteManagerConstructor } from '../../../managers/note.manager';
import { GlobalService } from '../../../services/global.service';
import { BaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { CreditCard, CreditCardArray, CreditCardTypes } from '../../../models/domain/credit.card';
import { ssApiService } from '../../../services/ss-api.service';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

import { KeyValuePair } from '../../../models/KeyValuePair';

import { Note, NoteTypes } from '../../../models/domain/note';
import { NoteManager } from '../../../managers/note.manager';
import { DialogService } from '../../../services/modal-dialogs';
import { AddCreditCardDialog } from '../../../dialogs/add.credit.card/add.credit.card.dialog';
import { CreditCardSetActiveRequest } from '../../../models/ss-api/requests/credit.card.set.active.request';
import { DecryptCreditCardRequest } from '../../../models/ss-api/requests/decrypt.credit.card.request';
import { CreditCardSetHiddenRequest } from '../../../models/ss-api/requests/credit.card.set.hidden.request';
import { EditCreditCardDialog } from '../../../dialogs/edit.credit.card/edit.credit.card.dialog';
import { UserRolesService } from '../../../services/user.roles.service';
import { WindowSettings } from '../../../../app/services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { SortBot } from '../../../../app/helpers/sort';
import { MemberDashboard } from '../../../../app/models/ss-api/responses/member.dashboard.response';


@Component({
    selector: 'credit-card-list',
    templateUrl: './credit.card.list.component.html',
    styleUrls: ['./credit.card.list.component.css']
})
export class CreditCardListComponent implements OnInit, OnDestroy {

    IsBusy: boolean = false;
    @Input('MemberID') MemberID: number;
    @Input('Member') Member: MemberDashboard;

    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    Data: CreditCardArray;
    noteChangeSubscription: Subscription;

    ccStatus: SelectItem[];
    selectedccStatus: string;

    creditCardSearch: string;
    creditCardResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    sortByDate() { this.Data = SortBot.SortAuto<CreditCardArray>(this.Data, 'DateTimeCreated'); }
    sortByCardType() { this.Data = SortBot.SortAuto<CreditCardArray>(this.Data, 'CardType'); }
    sortByFirstName() { this.Data = SortBot.SortAuto<CreditCardArray>(this.Data, 'FirstName'); }
    sortByLastFour() { this.Data = SortBot.SortAuto<CreditCardArray>(this.Data, 'LastFour'); }
    sortByExpDate() { this.Data = SortBot.SortAuto<CreditCardArray>(this.Data, 'ExpYear'); }
    sortByStatus() { this.Data = SortBot.SortAuto<CreditCardArray>(this.Data, 'Status'); }
    sortByCharges() { this.Data = SortBot.SortAuto<CreditCardArray>(this.Data, 'Charges'); }
    sortByFailed() { this.Data = SortBot.SortAuto<CreditCardArray>(this.Data, 'Failed'); }

    constructor(private api: ssApiService, private sweetAlertService: SweetAlertService, private globals: GlobalService, private memberEvents: MemberEventsService, private dialogService: DialogService, public roles: UserRolesService, private windowService: WindowService) {
        this.ccStatus = [];
        this.ccStatus.push({ label: 'Select status', value: null });
        this.ccStatus.push({ label: 'OK', value: { id: 1, name: 'ok' } });
        this.ccStatus.push({ label: 'Inactive', value: { id: 2, name: 'inactive' } });
    }

    ngOnInit() {
        this.noteChangeSubscription = this.memberEvents.onNoteChanged.subscribe(args => this.onNoteChanged(args));
    }

    ngOnDestroy() {
        this.noteChangeSubscription.unsubscribe();
    }


    onNoteChanged(args: EntityChangedArgs<Note>) {

        let CreditCardID = Note.GetNoteTypeValue(args.Original.NoteTypeList, NoteTypes.CreditCard);

        if (CreditCardID == 0)
            return;

        // search for GIS Bundle
        let CreditCard = this.Data.find(x => x.ID == CreditCardID);
        if (CreditCard != undefined) {
            // we found the bundle
            CreditCard.HasNotes = true
            return;
        }

    }


    ShowCCNumbers() {

        alert('test');

    }

    ShowCCNumber(item: CreditCard) {

        if (!this.roles.RestrictedAccess(1))
            return;

        let Request = new DecryptCreditCardRequest();
        Request.AdminUsername = this.globals.Email;
        Request.CardID = item.ID;

        this.IsBusy = true;

        // confirm
        this.sweetAlertService.swal({
            title: 'Password',
            input: 'password',
            showCloseButton: true,
            showCancelButton: false,
            confirmButtonText: 'Submit',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: (password) => {

                if (password == '') {
                    // return
                    this.ShowCCNumber(item);
                } else {
                    Request.AdminPassword = password;
                    this.RequestDecryptCCard(Request);
                }
            }
        }).then(
            (response: any) => { },
            (dismiss) => {
                this.IsBusy = false;
            });

    }

    showAddCreditCard() {
		
		if( this.Member.Address1 == '' || this.Member.Address1 == undefined
			|| this.Member.City == '' || this.Member.City == undefined
			|| this.Member.State == '' || this.Member.State == undefined
			|| this.Member.Zip == '' || this.Member.Zip == undefined ) {
			
			this.sweetAlertService.swal({
				title: 'Error',
				text: 'Member must have a valid address to add a credit card. Please update address on account.',
				type: 'error',
				showCancelButton: false,
				showConfirmButton: true,
				confirmButtonText: 'OK',
			}).then((response: any) => { }, (dismiss) => { });

			return;
		}
		
		let disposable = this.dialogService.addDialog(AddCreditCardDialog, {
            MemberID: this.MemberID,
			Member: this.Member,
			title : '', subTitle : '', message: ''
        }, { height: 800 }).subscribe(result => {
            disposable.unsubscribe();
            this.reloadCards();
        });
    }

    RequestDecryptCCard(request: DecryptCreditCardRequest) {

        // request
        this.api.DecryptCreditCard(request).subscribe(
            (result) => {

                this.IsBusy = false;

                if (!result.Result) {
                    // error
                    this.sweetAlertService.swal({
                        title: 'Error',
                        text: result.Data,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    }).then((response: any) => { }, (dismiss) => { }); // keep this line to prevent promise error;

                    return;
                }

                // get the number
                let number = result.Data;

                // show cancelled
                this.sweetAlertService.swal({
                    imageUrl: './assets/images/Credit_Card-512.png',
                    imageWidth: 150,
                    imageHeight: 150,
                    title: '',
                    html: '<h1>' + number + '</h1>',
                    showCancelButton: false,
                    confirmButtonText: 'Close',
                    allowOutsideClick: false,
                    showCloseButton: true,
                    showConfirmButton: false
                }).then((response: any) => { }, (dismiss) => { }); // keep this line to prevent promise error;

            },

            (error: any) => {
                console.log(error);
                this.IsBusy = false;
            }

        );
    }

    CardTypeToString(cardType: CreditCardTypes): string {
        return CreditCardTypes[cardType];
    }

    public Load() {

        this.IsBusy = true;

        this.api.getCCards(this.MemberID).subscribe(
            (result: BaseResponse<CreditCardArray>) => {
                this.Data = result.Data;
                this.IsBusy = false;
                this.SortCardsByDefaultFirst();
            },
            (error: any) => {
                this.IsBusy = false;
            }
        );

    }


    // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Sort Data array of credit cards by DateCreated, then move the Deafult Card to the first position in the array
    // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    SortCardsByDefaultFirst() {

        this.Data = SortBot.SortAuto(this.Data, 'DateTimeCreated');

        // find index
        let i = this.Data.findIndex(o => o.Status === 'Default');

        // if already at start, nothing to do
        if (i <= 0) return false;

        let defaultItem = this.Data[i];

        this.Data.splice(i, 1);

        this.Data.unshift(defaultItem);

    }

    onNoteClick(item: CreditCard) {
        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.LicenseKey, item.ID);

        let noteData = new NoteManagerConstructor(item.ID);
        noteData.NoteType = type;

        let noteManager = new NoteManager(noteData);
    }

    private GetNoteManagerContructData(creditCard: CreditCard): NoteManagerConstructor {

        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.CreditCard, creditCard.ID);
        let noteData = new NoteManagerConstructor();
        noteData.MemberID = this.MemberID;
        noteData.NoteType = type;
        noteData.RelationInfo = creditCard.LastFour;
        noteData.RelationObject = creditCard;

        return noteData;
    }

    AddNote(creditCard: CreditCard) {
        // add new
        let noteData = this.GetNoteManagerContructData(creditCard);
        noteData.IsAddNote = true;

        // let noteManager = new NoteManager(noteData);
        this.ShowNoteWindow(noteData);
    }

    EditNote(creditCard: CreditCard) {

        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.CreditCard, creditCard.ID);

        if (creditCard.HasNotes) {
            // load
            let noteData = this.GetNoteManagerContructData(creditCard);
            noteData.NoteID = creditCard.ID;
            // let noteManager = new NoteManager(noteData);
            this.ShowNoteWindow(noteData);
        } else {
            // add new
            this.AddNote(creditCard);
        }

    }

    ShowNoteWindow(noteData: NoteManagerConstructor) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<NoteManagerConstructor>(WindowTypes.Note, noteData, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
                this.onNoteChanged(event.Data);
            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });
    }

    async makeCardDefault(creditCard: CreditCard) {
        this.IsBusy = true;
        await this.sweetAlertService.swal(
            {
                title: 'Set as Default?',
                text: 'Are you sure you want to set this card as the default?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
            })
            .then(async response => {

                await this.api.CreditCardSetAsDefault(creditCard.ID).subscribe(response => {
                    this.IsBusy = false;
                    this.reloadCards();
                    this.sweetAlertService.swal(
                        {
                            title: 'Success!',
                            text: 'Card Set as Default',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        .then((response: any) => {
                            this.IsBusy = false;

                        }, (dismiss) => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                }, error => {
                    this.IsBusy = false;
                });


            }, (dismiss) => {
                this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.IsBusy = false;
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });



    }

    async deleteCard(creditCard: CreditCard) {
        this.IsBusy = true;
        await this.sweetAlertService.swal(
            {
                title: 'Delete Card?',
                text: 'Are you sure you want to delete the card ending in ' + creditCard.LastFour + '?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
            })
            .then(async response => {
                await this.api.DeleteCreditCard(creditCard.ID).subscribe(response => {
                    this.sweetAlertService.swal(
                        {
                            title: 'Success!',
                            text: 'Card Deleted',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        }).then((response: any) => {
                            this.IsBusy = false;
                        }, (dismiss) => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                    this.IsBusy = false;
                    this.reloadCards();
                }, error => {
                    this.IsBusy = false;
                });
            }, (dismiss) => {
                this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.IsBusy = false;
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });
    }

    reloadCards() {
        this.onRefresh.emit('');
    }

    isExpired(Item: CreditCard): boolean {
        let currentYear = new Date().getFullYear();
        let currentMonth = new Date().getMonth();
        if (Item.ExpYear + 2000 < currentYear)
            return true;
        else if (Item.ExpYear + 2000 == currentYear && Item.ExpMonth < currentMonth)
            return true

        return false;
    }

    isInactive(Item: CreditCard): boolean {
        return Item.Status == 'Inactive';
    }


    async DeactivateCard(creditCard: CreditCard, isActive: boolean = false) {
        this.IsBusy = true;

        let newTitle: string = 'Deactivate Card?'
        let newText: string = 'Are you sure you want to deactivate the card ending in ' + creditCard.LastFour + '?';
        if (isActive == true) {
            newTitle = 'Activate Card?'
            newText = 'Are you sure you want to activate the card ending in ' + creditCard.LastFour + '?';
        }

        await this.sweetAlertService.swal(
            {
                title: newTitle,
                text: newText,
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
            })
            .then(async response => {
                let request = new CreditCardSetActiveRequest;

                request.CreditCardID = creditCard.ID;
                request.IsActive = isActive;

                await this.api.CreditCardSetActive(request).subscribe(response => {
                    this.sweetAlertService.swal(
                        {
                            title: 'Success!',
                            text: 'Card Deactivated',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        }).then((response: any) => {
                            this.IsBusy = false;
                        }, (dismiss) => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                    this.IsBusy = false;
                    this.reloadCards();
                }, error => {
                    this.IsBusy = false;
                });
            }, (dismiss) => {
                this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.IsBusy = false;
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });
    }

    async HideCard(creditCard: CreditCard, isHidden: boolean = false) {
        this.IsBusy = true;

        let newTitle: string = 'Hide Card?'
        let newText: string = 'Are you sure you want to hide the card ending in ' + creditCard.LastFour + '?';

        if (!isHidden) {
            newTitle = 'Set card to visible?'
            newText = 'Are you sure you want to set this card to visible?';
        }

        await this.sweetAlertService.swal(
            {
                title: newTitle,
                text: newText,
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
            })
            .then(async response => {

                let request = new CreditCardSetHiddenRequest;

                request.CreditCardID = creditCard.ID;
                request.IsHidden = isHidden;

                await this.api.CreditCardHide(request).subscribe(response => {
                    this.sweetAlertService.swal(
                        {
                            title: 'Success!',
                            text: 'Action OK.',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        }).then((response: any) => {
                            this.IsBusy = false;
                        }, (dismiss) => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                    this.IsBusy = false;
                    this.reloadCards();
                }, error => {
                    this.IsBusy = false;
                });
            }, (dismiss) => {
                this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.IsBusy = false;
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });
    }


    EditCard(card: CreditCard) {
        let disposable = this.dialogService.addDialog(EditCreditCardDialog, {
            creditCard: card
        }, { height: 400 }).subscribe(result => {
            disposable.unsubscribe();
            this.reloadCards();
        });
    }

    paginateCreditCards(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
